import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import VantageView from './vantage.presenter';

import {
  VANTAGE_AUTHORABLE_CONTENT,
  COMPLETE_EVENT_DOWNLOAD_PDF_PROCESS,
  INITIATE_EVENT_DOWNLOAD_PDF_PROCESS,
  FAILURE_EVENT_DOWNLOAD_PDF_PROCESS,
  COMPLETE_EMAIL_EVENT_REPORT,
  INITIATE_EMAIL_EVENT_REPORT,
  FAILURE_EMAIL_EVENT_REPORT,
  HIDE_GENERIC_ERROR_MODAL,
  UPDATE_SELECTED_SLIDES,
  OPEN_CALLBACK_REQUEST_MODAL,
  CLOSE_CALLBACK_REQUEST_MODAL,
} from '../../app-constants';

import {
  getEventUserId,
  startEventDownloadPdfProcess,
  emailEventReport,
  sendCallbackRequest,
  eventsTrackResourceViews,
  updateSelectedSlides,
  getPageType,
  hideGenericErrorModal,
  openCallbackRequestModal,
  closeCallbackRequestModal,
  getEventId,
} from './vantage.actions';

// Reducer
export const vantageReducer = (state = {
  loading: false,
  downloadTripReportIsLoading: false,
  emailTripReportIsSending: false,
  selectedSlides: [],
  showGenericErrorModal: false,
  callbackRequestModalIsOpen: false,
}, action) => {
  switch (action.type) {
    case OPEN_CALLBACK_REQUEST_MODAL:
      return { ...state, callbackRequestModalIsOpen: true };
    case CLOSE_CALLBACK_REQUEST_MODAL:
      return { ...state, callbackRequestModalIsOpen: false };
    case COMPLETE_EVENT_DOWNLOAD_PDF_PROCESS:
      return { ...state, downloadTripReportIsLoading: false };
    case COMPLETE_EMAIL_EVENT_REPORT:
      return { ...state, emailTripReportIsSending: false };
    case INITIATE_EVENT_DOWNLOAD_PDF_PROCESS:
      return { ...state, downloadTripReportIsLoading: true };
    case INITIATE_EMAIL_EVENT_REPORT:
      return { ...state, emailTripReportIsSending: true };
    case FAILURE_EVENT_DOWNLOAD_PDF_PROCESS:
      return { ...state, downloadTripReportIsLoading: false, showGenericErrorModal: true };
    case FAILURE_EMAIL_EVENT_REPORT:
      return { ...state, emailTripReportIsSending: false, showGenericErrorModal: true };
    case HIDE_GENERIC_ERROR_MODAL:
      return { ...state, showGenericErrorModal: false };
    case UPDATE_SELECTED_SLIDES:
      return { ...state, selectedSlides: action.data };
    default:
      return state;
  }
};

export const mapStateToProps = state => ({
  authorableContent: state.authorableContentReducer.authorableContent.discover
    ? state.authorableContentReducer.authorableContent
    : VANTAGE_AUTHORABLE_CONTENT,
  vantage: state.dataBootStrapReducer.data,
  // if location hash is present, then we extract userId for vantage view, otherwise null for generic view
  uId: window.location.hash.length > 1 ? getEventUserId() : null,
  eventId: getEventId(),
  downloadTripReportIsLoading: state.vantageReducer.downloadTripReportIsLoading,
  emailTripReportIsSending: state.vantageReducer.emailTripReportIsSending,
  selectedSlides: state.vantageReducer.selectedSlides,
  showGenericErrorModal: state.vantageReducer.showGenericErrorModal,
  pageType: getPageType(),
  callbackRequestModalIsOpen: state.vantageReducer.callbackRequestModalIsOpen,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    startEventDownloadPdfProcess,
    emailEventReport,
    sendCallbackRequest,
    eventsTrackResourceViews,
    updateSelectedSlides,
    hideGenericErrorModal,
    openCallbackRequestModal,
    closeCallbackRequestModal,
  }, dispatch),
});

const Vantage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(VantageView);

export default Vantage;
